module.exports = __webpack_public_path__ + "img/main-product.74aabf7f.jpg";